import { fileDownload } from '@/utils'
import axios from '@/user/axios.js'

const moduleReports = {
  namespaced: true,
  state: {
    asindata: [],
    asinxdaydata: [],
    asinxmonthdata: [],
    daydata: [],
    monthdata: []
  },

  getters: {
    asinData: state => {
      return state.asindata
    },
    asinxdayData: state => {
      return state.asinxdaydata
    },
    asinxmonthData: state => {
      return state.asinxmonthdata
    },
    dayData: state => {
      return state.daydata
    },
    monthData: state => {
      return state.monthdata
    }
  },

  mutations: {
    SET_ASINDATA (state, data) {
      state.asindata = data
    },
    SET_ASINXDAYDATA (state, data) {
      state.asinxdaydata = data
    },
    SET_ASINXMONTHDATA (state, data) {
      state.asinxmonthdata = data
    },
    SET_DAYDATA (state, data) {
      state.daydata = data
    },
    SET_MONTHDATA (state, data) {
      state.monthdata = data
    }
  },
  actions: {
    getAsin: async (context, payload) => {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/sales-reports/${sellerId}/asin`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_ASINDATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getAsinDay (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/sales-reports/${sellerId}/asinxday`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_ASINXDAYDATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getAsinMonth (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/sales-reports/${sellerId}/asinxmonth`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_ASINXMONTHDATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getDay (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/sales-reports/${sellerId}/day`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_DAYDATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getMonth (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/sales-reports/${sellerId}/month`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_MONTHDATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        const { action, ...paramData } = payload
        try {
          const res = await axios.get(`/api/sales-reports/download/${sellerId}/${action}`, {
            responseType: 'blob',
            params: paramData
          })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleReports
